export enum PipType {
  Call = "call",
  DealActivity = "deal_activity",
}
